import { useFeatureFlag } from '@moda/portal-stanchions';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { useUser } from '../../hooks/useUser';
import { hrefFor } from '../../routers';
import { CuratedLooksNotificationsComponent } from './CuratedLooksNotificationsComponent';

export const CuratedLooksNotifications = () => {
  const featureEnabled = useFeatureFlag('curated-looks-notifications', [
    { default: false },
    { if: true, then: true }
  ]);

  const { pathname } = useLocation();

  const {
    user: { isLoggedIn }
  } = useUser();

  if (!featureEnabled) return null;

  if (!isLoggedIn) return null;

  if (pathname === hrefFor.CheckoutPage()) return null;

  return <CuratedLooksNotificationsComponent />;
};
